import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { Divider, Dimmer, Icon, Button, Form, Grid, Header, Image, Segment } from 'semantic-ui-react';
import * as LocalStorageManager from '../../util/StorageManager';
import { isDefined } from '../../util/Common';
import AuthService from '../../util/Authenticate';
import { ErrorMessage } from '../../components/Message';

class LoginPage extends Component {
    
    constructor(){
        super();
        this.state = {
            documento: '',
            senha: '',
            tipoLogin: 'cliente',
            isLoading: false
        }
    }

    setDocumento(documento){
        documento = documento.replace(/\D/g, '');
        
        if (documento.length === 11){
            documento = documento.substring(0, 14).replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, '$1.$2.$3-$4');
        } else if (documento.length >= 14){
            documento = documento.substring(0, 14).replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, '$1.$2.$3/$4-$5');
        }

        this.setState({documento});
    }

    setSenha(senha){
        this.setState({ senha });
    }

    handleChangeTipoLogin = (e, { name }) => {
        this.setState({ tipoLogin: name });
    }

    login = () => {
        this.setState({ isLoading: true });
        AuthService.login(this.state.documento, this.state.senha, this.state.tipoLogin, this.redirectAfterLogin);
    }

    redirectAfterLogin = () => {
        this.setState({ isLoading: false });

        if(LocalStorageManager.isLoggedIn()){
            /* Fez login */
            this.props.history.push(isDefined(this.props.location.state) ? this.props.location.state.from.pathname : '/main');
        }else{
            let mensagem;

            if(this.state.documento.length === 0 || this.state.senha.length === 0){
                mensagem = 'Preencha o usuário e a senha corretamente';
            }else{
                mensagem = 'Usuário ou senha incorreto';
            }
            
            this.setState({ mensagem, senha: '' });
        }
    }

    render() {
        const { tipoLogin, documento, senha, mensagem, isLoading } = this.state;

        return (
            LocalStorageManager.isEmpresaSet() ? (
                AuthService.isAuthenticated() ? (
                    <Redirect to={{
                        pathname: '/main'
                    }}/>
                ) : (
                    <div className='login-form'>
                        <Helmet>
                            <title>{LocalStorageManager.getEmpresa().nome}</title>
                            <link rel="shortcut icon" href={LocalStorageManager.getEmpresa().logo}/>
                        </Helmet>
                        <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
                            <Grid.Column style={{ maxWidth: 450 }}>
                                <style>
                                    {`
                                    body > div,
                                    body > div > div,
                                    body > div > div > div.login-form {
                                        height: 100%;
                                    }
                                    `}
                                </style>
                                <Header as='h2' color={LocalStorageManager.getEmpresa().corTema} textAlign='center'>
                                    <Image src={LocalStorageManager.getEmpresa().logo} shape='rounded'/>
                                    {' ' + LocalStorageManager.getEmpresa().razaoSocial}
                                </Header>
                                <Segment raised color={LocalStorageManager.getEmpresa().corTema}>
                                    <Form size='small' onSubmit={this.login}>
                                        <Button.Group fluid widths={2}>
                                            <Button type='button' name='cliente' content='Cliente' secondary={tipoLogin === 'cliente'} onClick={this.handleChangeTipoLogin} />
                                            <Button type='button' name='representante' content='Representante' secondary={tipoLogin === 'representante'} onClick={this.handleChangeTipoLogin} />
                                        </Button.Group>
                                        <Divider />
                                        <Form.Input fluid icon='user' iconPosition='left' placeholder='CPF ou CNPJ' name="documento" value={documento} onChange={(evento) => this.setDocumento(evento.target.value)} />
                                        <Form.Input fluid icon='lock' iconPosition='left' placeholder='Senha' className='senha' type='password' name="senha" value={senha} onChange={(evento) => this.setSenha(evento.target.value)} />
                                        <Button color={LocalStorageManager.getEmpresa().corTema} fluid loading={isLoading} size='large' type='submit'>Entrar</Button>
                                    </Form>
                                </Segment>
                                <ErrorMessage text={mensagem}/>
                            </Grid.Column>
                        </Grid>
                    </div>
                )
            ) : (
                <Dimmer active page>
                    <Header as='h2' icon inverted>
                        <Icon name='remove circle'/>
                        Nenhuma empresa selecionada!
                    </Header>
                </Dimmer>
            )
        )
    }
}

export default withRouter(LoginPage);



// WEBPACK FOOTER //
// ./src/views/LoginPage/index.js